import { render, staticRenderFns } from "./RegistrationNumbersUpload.vue?vue&type=template&id=6e72f8fe"
import script from "./RegistrationNumbersUpload.vue?vue&type=script&lang=js"
export * from "./RegistrationNumbersUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports